<template>
  <!-- class="sidebar sidebar-right" -->
  <div
    class=""
    :class="
      global.showSidebar === true ? 'pace-done pace-done aside-right-open' : ''
    "
  >
    <aside class="sidebar sidebar-right">
      <!-- class="sidebar-content" -->
      <div class="sidebar-content">
        <!--  -->
        <button type="button" class="close mb-2" @click="closeSidebar()">
          <span aria-hidden="true"
            ><i class="icon dripicons-cross myclose"></i
          ></span>
        </button>

        <!-- 導航項目 -->
        <div class="row col-sm-12 mx-0 px-0 mb-3">
          <div
            v-for="item in allNavItems"
            :key="item.path"
            class="col-3 func-height pointer border px-0 mx-0 mb-3 d-flex justify-content-center"
            @click="handleNavItemClick(item)"
          >
            <div
              class="d-flex flex-column align-items-center justify-content-center"
            >
              <i
                :class="[
                  item.icon,
                  'icon text-center header-text',
                  global.lightHeaderText === item.tag ? 'text-primary' : '',
                ]"
              ></i>
              <div
                class="text-center m-text msu-semibold header-text mt-1"
                :class="
                  global.lightHeaderText === item.tag ? 'text-primary' : ''
                "
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>

        <!-- Quick Access (B2C 用戶) -->
        <div v-if="userCustomization.userGroup === 'B2C'" class="mb-3">
          <h6 class="pl-3 text-left mb-2 msu-semibold activity-title-color">
            {{ $t("Quick Access") }}
          </h6>
          <div class="row col-12 px-0 mx-0">
            <div
              v-for="item in userCardBtnItems"
              :key="item.title"
              class="col-3 pa-1 mb-3"
              @click="goSiteAndHide(item.link)"
            >
              <div class="position-relative">
                <img
                  :src="getButtonImage(item.imageType)"
                  class="img-fluid activity-btn-img"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- English 活動 (B2C 用戶) -->
        <div v-if="userCustomization.userGroup === 'B2C'" class="mb-3">
          <h6 class="pl-3 text-left mb-2 msu-semibold activity-title-color">
            {{ $t("English") }}
          </h6>
          <div class="row col-12 px-0 mx-0">
            <div
              v-for="i in userCardActivities.english.items"
              :key="`sidebar-english-${i}`"
              class="col-3 pa-1 mb-3"
              @click="goExternalLink(i, 'english')"
            >
              <img
                :src="getActivityImage(i, 'english')"
                class="img-fluid activity-btn-img"
              />
            </div>
          </div>
        </div>

        <!-- Relax 活動 (B2C 用戶) -->
        <div v-if="userCustomization.userGroup === 'B2C'" class="mb-3">
          <h6 class="pl-3 text-left mb-2 msu-semibold activity-title-color">
            {{ $t("Relax") }}
          </h6>
          <div class="row col-12 px-0 mx-0">
            <div
              v-for="i in userCardActivities.relax.items"
              :key="`sidebar-relax-${i}`"
              class="col-3 pa-1"
              @click="goExternalLink(i, 'relax')"
            >
              <img
                :src="getActivityImage(i, 'relax')"
                class="img-fluid activity-btn-img"
              />
            </div>
          </div>
        </div>

        <!--  -->
      </div>
    </aside>
  </div>
</template>
<script setup>
import { ApiGetHomeFunc } from "@/service/apis/learnInfo";
import { useI18n } from "vue-i18n";
import { useGlobalStore } from "@/store/modules/global";
import { useUserCustomizationStore } from "@/store/modules/userCustomization";
import { useUserInfoStore } from "@/store/modules/userInfo";

const { locale, t } = useI18n({
  inheritLocale: true,
});

const global = useGlobalStore();
const userCustomization = useUserCustomizationStore();
const user = useUserInfoStore();

const langList = computed(() => {
  return global.langList;
});
const changeLang = (lang) => {
  if (locale.value !== lang) {
    locale.value = lang;
    // i18n.global.locale.value = lang;
    localStorage.setItem("locale", locale.value);
    window.location.reload();
  }
};
const closeSidebar = () => {
  global.$patch((state) => {
    state.showSidebar = false;
  });
};
const openNotify = () => {
  $(`#modal-notify`).modal("show");
};
// const changeLightHeaderText = (text) => {
//   global.$patch((state) => {
//     state.lightHeaderText = text;
//   });
// };
const $goPage = inject("$goPage");

// 使用客製化配置的導航項目
const navItem = computed(() => {
  const filteredNavItems = userCustomization.filteredNavItems;

  // 將配置轉換為組件需要的格式
  return filteredNavItems.map((item) => ({
    path: item.path,
    name: t(item.name),
    icon:
      item.icon === "dripicons-home"
        ? "fas fa-house"
        : item.icon === "dripicons-graduation"
        ? "fas fa-graduation-cap"
        : item.icon === "fa-solid fa-robot"
        ? "fas fa-robot"
        : item.icon === "dripicons-trophy"
        ? "fas fa-trophy"
        : item.icon === "dripicons-calendar"
        ? "fas fa-calendar"
        : "fas fa-house",
    tag: item.tag,
  }));
});

// 所有導航項目（包含 Notify），一排4個
const allNavItems = computed(() => {
  const allItems = [...navItem.value];

  // 添加 Notify 按鍵到導航項目中
  allItems.push({
    path: "#notify",
    name: t("Notify"),
    icon: "fa-regular fa-bell",
    tag: "notify",
  });

  return allItems;
});

// UserCard 相關功能
const userCardBtnItems = computed(() => {
  return userCustomization.filteredUserCardBtnItems.map((item) => ({
    ...item,
    title: t(item.title),
  }));
});

const userCardActivities = computed(() => {
  return userCustomization.userCardActivities;
});

// 獲取按鈕圖片
const getButtonImage = (buttonType) => {
  return new URL(
    `../assets/img/activity_icon/functionimg/${buttonType}.png`,
    import.meta.url
  ).href;
};

// 獲取活動圖片
const getActivityImage = (index, activityType) => {
  if (activityType === "english") {
    return new URL(`../assets/img/activity_icon/e${index}.png`, import.meta.url)
      .href;
  } else if (activityType === "relax") {
    return new URL(
      `../assets/img/activity_icon/game${index}.png`,
      import.meta.url
    ).href;
  }
};

// 獲取提示值
const getHintValue = (hintType) => {
  if (hintType === "totalReward") {
    return user.hint.totalReward;
  }
  return "";
};

// 外部連結跳轉
const goExternalLink = (index, activityType) => {
  const currentLang = locale.value;
  if (activityType === "english") {
    if (index === 1) {
      $goPage(`/msu/phrasal-verb?LANG=${currentLang}`);
    } else if (index === 2) {
      $goPage(`/msu/daily-conversation?LANG=${currentLang}`);
    } else if (index === 4) {
      let token = localStorage.getItem("token");
      let link = `https://ai-edu.mangosteems.com/ai_speak/?lang=${currentLang}&auth=${token}?userid=${user.student.stuID}`;
      window.open(link, "_blank");
    } else if (index === 3) {
      $goPage(`/msu/practice-words`);
    } else if (index === 5) {
      $goPage(`/msu/english-central`);
    }
  } else if (activityType === "relax") {
    if (index === 1) {
      // 處理 index 1 的情況
    } else if (index === 2) {
      let token = localStorage.getItem("token");
      let link = `https://whacamole.mangosteems.com/?auth=${token}&LANG=${currentLang}`;
      window.open(link, "_blank");
    } else if (index === 3) {
      let token = localStorage.getItem("token");
      let link = `https://cardgame.mangosteems.com/?auth=${token}&LANG=${currentLang}`;
      window.open(link, "_blank");
    }
  }
  closeSidebar();
};

const handleNavItemClick = (item) => {
  if (item.path === "#notify") {
    openNotify();
  } else {
    goSiteAndHide(item.path);
  }
};
const getHomeFunc = async () => {
  let result = await ApiGetHomeFunc.get();
  // console.log(result);
};
const goSiteAndHide = (path) => {
  $goPage(path);
  closeSidebar();
};
onMounted(() => {
  console.log("home side bar");
  getHomeFunc();
});
</script>
<style lang="scss" scoped>
.func-height {
  min-height: 100px; // 增加高度以容納更大的圖標
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 12px; // 增加內邊距
}

.header-text:hover {
  color: #32c1db !important;
}

//
div.aside-right-open .sidebar-right {
  box-shadow: 0 0 15px 1px rgb(69 65 78 / 20%);
  right: 0;
  overflow-y: auto; // 允許垂直滾動
  overflow-x: hidden; // 隱藏水平滾動
  display: block;
}
//

.sidebar-right {
  order: 3;
  z-index: 1005;
  position: fixed;
  overflow-y: auto; // 添加垂直滾動
  overflow-x: hidden; // 隱藏水平滾動
  width: 800px !important; // 增加寬度
  right: -900px;
  padding: 25px;
  background-color: #fff;

  // 響應式設計 - 小螢幕適配
  @media (max-width: 1200px) {
    width: 700px !important;
    right: -800px;
    padding: 20px;
  }

  @media (max-width: 992px) {
    width: 600px !important;
    right: -700px;
    padding: 18px;
    overflow-y: auto; // 確保在小於992px時可以滾動
    max-height: 100vh; // 限制最大高度為視窗高度
  }

  @media (max-width: 768px) {
    width: 450px !important;
    right: -550px;
    padding: 15px;
    overflow-y: auto; // 確保在小於768px時可以滾動
    max-height: 100vh; // 限制最大高度為視窗高度
  }

  @media (max-width: 576px) {
    width: 380px !important;
    right: -480px;
    padding: 12px;
    overflow-y: auto; // 確保在小於576px時可以滾動
    max-height: 100vh; // 限制最大高度為視窗高度
  }

  @media (max-width: 480px) {
    width: 340px !important;
    right: -440px;
    padding: 10px;
    overflow-y: auto; // 確保在小於480px時可以滾動
    max-height: 100vh; // 限制最大高度為視窗高度
  }
}

.customizer-panel-wrapper,
.sidebar-right {
  display: block !important;
  top: 0;
  bottom: 0;
  backface-visibility: hidden;
  transition: all 0.3s ease;
}

.myclose {
  font-size: 40px;

  @media (max-width: 768px) {
    font-size: 32px;
  }

  @media (max-width: 576px) {
    font-size: 28px;
  }
}

// 活動按鈕圖片樣式
.activity-btn-img {
  width: 100px; // 桌上型電腦固定寬度 - 放大
  height: 100px; // 桌上型電腦固定高度 - 放大
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.2s ease;
  border-radius: 10px; // 添加圓角
}

.activity-btn-img:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); // 添加陰影效果
}

// 導航項目圖標樣式 - 統一大小
.icon {
  font-size: 2rem !important; /* 統一圖標大小 - 放大 */
  width: 55px; // 統一寬度 - 放大
  height: 55px; // 統一高度 - 放大
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px; // 添加圓角
  background-color: #f8f9fa; // 添加背景色
  transition: all 0.2s ease;
}

.icon:hover {
  background-color: #e9ecef;
  transform: scale(1.05);
}

@media (max-width: 768px) {
  .icon {
    font-size: 1.65rem !important;
    width: 60px; // 小螢幕時調整大小
    height: 60px;
  }

  .activity-btn-img {
    width: 95px; // 平板或手機時調整
    height: 95px;
  }

  .func-height {
    min-height: 80px; // 小螢幕時調整高度
    padding: 8px; // 調整內邊距
  }
}

@media (max-width: 576px) {
  .icon {
    font-size: 1.35rem !important;
    width: 52px; // 更小螢幕時調整大小
    height: 52px;
  }

  .activity-btn-img {
    width: 90px; // 手機時
    height: 90px;
  }

  .func-height {
    min-height: 75px; // 更小螢幕時調整高度
    padding: 6px; // 調整內邊距
  }
}

// 響應式文字大小
.m-text {
  font-size: 1rem !important; // 增加基礎文字大小

  @media (max-width: 768px) {
    font-size: 0.95rem !important;
  }

  @media (max-width: 576px) {
    font-size: 0.85rem !important;
  }
}

// 確保內容在小螢幕上不會溢出
.sidebar-content {
  @media (max-width: 768px) {
    padding: 0 5px;
  }

  @media (max-width: 576px) {
    padding: 0 2px;
  }
}

// 活動標題顏色
.activity-title-color {
  color: #828282;
  font-size: 1.1rem !important; // 增加標題字體大小

  @media (max-width: 768px) {
    font-size: 1rem !important;
  }

  @media (max-width: 576px) {
    font-size: 0.95rem !important;
  }
}

// 為右側邊欄添加自定義滾動條樣式
.sidebar-right::-webkit-scrollbar {
  width: 6px;
}

.sidebar-right::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.sidebar-right::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.sidebar-right::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
